(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-registration/assets/react/store/register-slice.js') >= 0) return;  svs.modules.push('/modules/player-registration/assets/react/store/register-slice.js');
"use strict";

var _svs$playerRegistrati, _svs$playerRegistrati2, _svs$playerRegistrati3;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const register = ((_svs$playerRegistrati = svs.playerRegistration) === null || _svs$playerRegistrati === void 0 || (_svs$playerRegistrati = _svs$playerRegistrati.data) === null || _svs$playerRegistrati === void 0 ? void 0 : _svs$playerRegistrati.extraData) || {
  theme: {}
};
const startTime = () => {
  const browserStorage = svs.components.Storage.browser;
  if (browserStorage) {
    const startTime = browserStorage.get('startTime', 'player_registration');
    if (startTime) {
      return startTime;
    }
    const newDate = Date.now();
    browserStorage.set('startTime', 'player_registration', newDate, svs.components.Storage.constants.EXPIRES_15M, () => {});
    return newDate;
  }
  return Date.now();
};
const formatProduct = product => {
  if (product) {
    switch (product) {
      case 'kenoxpress':
        return 'KenoXpress';
      case 'skrap7an':
        return 'Skrap7:an';
      default:
        return svs.utils.format.capitalize(product, true);
    }
  } else {
    return product;
  }
};

const getProductInfo = extraData => {
  var _extraData$product;
  const productLower = extraData === null || extraData === void 0 || (_extraData$product = extraData.product) === null || _extraData$product === void 0 ? void 0 : _extraData$product.toLowerCase();
  const ticketGames = ['triss', 'skrap7an'];
  const productInfoText = ticketGames.includes(productLower) ? {
    prefix: 'Din',
    suffix: 'lott'
  } : {
    prefix: 'Ditt',
    suffix: 'spel'
  };
  const productDisplayName = formatProduct(productLower);
  const subscriptionSuffix = extraData !== null && extraData !== void 0 && extraData.subscription ? ' / vecka' : '';
  const productInfo = {
    productDisplayName,
    productInfo: extraData !== null && extraData !== void 0 && extraData.product ? "".concat(productInfoText === null || productInfoText === void 0 ? void 0 : productInfoText.prefix, " ").concat(productDisplayName, "-").concat(productInfoText === null || productInfoText === void 0 ? void 0 : productInfoText.suffix) : '',
    productAmountInfo: extraData !== null && extraData !== void 0 && extraData.amount ? "".concat(extraData === null || extraData === void 0 ? void 0 : extraData.amount, " kr").concat(subscriptionSuffix) : ''
  };

  if ((extraData === null || extraData === void 0 ? void 0 : extraData.product) === 'supportern' && extraData !== null && extraData !== void 0 && extraData.team) {
    productInfo.productAmountInfo = "".concat(extraData === null || extraData === void 0 ? void 0 : extraData.team, " - ").concat(productInfo.productAmountInfo);
  } else if (productLower === 'skrap7an') {
    productInfo.productInfo = 'Din Skrap7:an-lott';
  }
  return productInfo;
};

const getProductCapitalized = extraData => {
  var _extraData$product2;
  const capitalizeString = svs.utils.format.capitalize;

  let productCapitalized = extraData !== null && extraData !== void 0 && extraData.product ? capitalizeString(extraData.product, true) : '';

  if ((extraData === null || extraData === void 0 || (_extraData$product2 = extraData.product) === null || _extraData$product2 === void 0 ? void 0 : _extraData$product2.toLowerCase()) === 'kenoxpress') {
    productCapitalized = 'KenoXpress';
  }
  return productCapitalized;
};
const registerSlice = RTK.createSlice({
  name: 'register',
  initialState: _objectSpread(_objectSpread({
    startTime: startTime()
  }, register), {}, {
    theme: svs.accountservices.onboardingHandler.getTheme(register === null || register === void 0 ? void 0 : register.branding),
    productInfo: getProductInfo(register),
    productCapitalized: getProductCapitalized(register)
  }),
  reducers: {
    setStandardBranding: state => {
      const standardBranding = null;
      state.theme = svs.accountservices.onboardingHandler.getTheme(standardBranding);
      state.productInfo = getProductInfo({});
      state.productCapitalized = getProductCapitalized({});
    }
  }
});
(_svs$playerRegistrati2 = svs.playerRegistration) === null || _svs$playerRegistrati2 === void 0 || (_svs$playerRegistrati2 = _svs$playerRegistrati2.data) === null || _svs$playerRegistrati2 === void 0 || delete _svs$playerRegistrati2.extraData;

((_svs$playerRegistrati3 = svs.playerRegistration.data) === null || _svs$playerRegistrati3 === void 0 ? void 0 : _svs$playerRegistrati3.register) && delete svs.playerRegistration.data.register;
svs.playerRegistration.store.playerregistrationactions = registerSlice.actions;
svs.playerRegistration.store.reducer = registerSlice.reducer;

 })(window);